import React, { useMemo } from 'react';
import { View } from 'react-native';
import { ScreenName } from '../../lib/enums';
import useBehaviorSubjectState from '../../hooks/rxjs/useSubjectState';
import { useCartSetActiveScreen } from '../../hooks/useCartNavigationHelper/useCartSwitcherEffect';
import { sessionSubject } from '../../state/sessionObservable';
import { useTheme } from '../../hooks/useTheme';
import SystemStatus from '../../component/System/SystemStatus/SystemStatus';
import { getStyles } from './IdleScreen.styles';
import { Attribution } from '../../component/Attribution/Attribution';
import { Media, hasRenderableMedia } from '../../component/Media/Media';
import { BrandMark } from '../../component/BrandMark/BrandMark';
import { resolveBrandColor, shouldShowAttribution } from '../../utils/branding';

const IdleScreen: React.FC = () => {
  useCartSetActiveScreen(ScreenName.IDLE);

  const { colors } = useTheme();
  const styles = useMemo(() => getStyles(colors), [colors]);

  const { value: session } = useBehaviorSubjectState(sessionSubject);
  const display = session?.device?.deviceProfile?.customerDisplay;
  const config = display?.idleScreen;
  const backgroundColor = resolveBrandColor(display?.brandColor);
  const hasMedia = hasRenderableMedia(config);
  const showAttribution = shouldShowAttribution(session?.currentOrganization);

  return (
    <View style={[styles.container, { backgroundColor }]}>
      {hasMedia && <Media config={config} />}
      <BrandMark
        logoUri={config?.logoUri}
        name={hasMedia ? undefined : session?.currentStore?.name}
        backgroundColor={backgroundColor}
        logoStyle={styles.logo}
      />
      <SystemStatus />
      {showAttribution && <Attribution />}
    </View>
  );
};

export default IdleScreen;
